<div class="app-switch" (click)="toggle()">
  <div class="app-sw-background" [ngClass]="{'app-sw-bg-off': !isOn, 'app-sw-bg-on': isOn}"></div>
  <div class="app-sw-toggle" [ngClass]="{'app-sw-toggle-off': !isOn, 'app-sw-toggle-on': isOn}"></div>
</div>